<template>
  <div :class="`fixed top-0 bottom-0 right-0 left-0 grid grid-cols-12 grid-rows-6 m-auto z-50 w-full h-full bg-gray-500/75 ${display}`">
    <div class="col-start-5 col-end-9 row-start-2 row-end-4 grid grid-cols-12 grid-rows-6 bg-white shadow shadow-gray-500 bg-white rounded-md">
      <p class="row-span-4 col-span-12 flex px-5 py-5 justify-center items-center text-sm text-center text-gray-500" v-html="message"></p>
      <div class="row-span-2 col-span-12 flex justify-center items-center w-full">
        <button
          v-if="confirm.show"
          @click="submitConfirm()"
          class="bg-green-500 px-3 m-1 w-32 h-10 rounded-md text-sm text-white">{{ confirm.text }}</button>
        <button
          v-if="cancel.show"
          @click="submitCancel()"
          class="bg-red-500 px-3 m-1 w-32 h-10 rounded-md text-sm text-white">{{ cancel.text }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupConfirm',
  data: () => ({
    display: 'hidden',
    message: null,
    confirm: {},
    cancel: {}
  }),
  methods: {
    show: function (msg, confirm = {}, cancel = {}) {
      this.display = 'block'
      this.message = msg
      this.confirm = {
        text: 'YA',
        show: true,
        handler: null,
        ...confirm
      }
      this.cancel = {
        text: 'BATAL',
        show: true,
        handler: null,
        ...cancel
      }
    },
    submitConfirm: function () {
      this.display = 'hidden'

      if (typeof this.confirm.handler === 'function') this.confirm.handler()
    },
    submitCancel: function () {
      this.display = 'hidden'

      if (typeof this.cancel.handler === 'function') this.cancel.handler()
    }
  }
}
</script>
